module.exports = __webpack_public_path__ + "img/cases-brand-suning--lazyload-11.9d2b780a.jpg";